import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './http';

/**
 * Cache/revalidação de dados de servidor (SPEC §3 — TanStack Query). Não re-tenta
 * erro de regra/permissão (4xx da API); re-tenta só falha de rede, uma vez.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (contagem, erro) => {
        if (erro instanceof ApiError && !erro.ehRede) return false;
        return contagem < 1;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
